"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var authenticate = function () { return ({
    userId: 1,
    jwt: '',
    role: 'admin',
    locale: 'en',
    expiresAt: (0, moment_1.default)(new Date()).add(15, 'm').toDate().toISOString(),
    platformJwt: '',
    isLearningPanel: true,
}); };
exports.default = authenticate;
